import React from "react";

export default function CustomSiteSection({ title, body }) {
  const paragraphs = String(body || "")
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (!title && !paragraphs.length) return null;

  return (
    <section className="custom-site-section scroll-animate">
      <div className="container">
        {title ? <h2 className="section-title">{title}</h2> : null}
        {paragraphs.map((paragraph, index) => (
          <p key={index} className="custom-site-section-text">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
}
